<template>
  <component
    :is="containerComponent"
    class="characters"
    :class="{
      'modal-presentation': presentation === 'modal',
      'panel-presentation': presentation === 'panel',
    }"
    @close="closeSheet"
    v-if="isDisplayed"
  >
    <template v-if="presentation === 'panel' && !hideSwitch" #actions>
      <button
        @click="showNightOrder"
        class="side-panel-button"
        :title="$t('reference.showNightOrder')"
        type="button"
      >
        <font-awesome-icon icon="cloud-moon" />
      </button>
    </template>
    <button
      v-if="presentation === 'modal' && !hideSwitch"
      @click="showNightOrder"
      class="toggle"
      :title="$t('reference.showNightOrder')"
      type="button"
    >
      <font-awesome-icon icon="cloud-moon" />
    </button>
    <h3>
      {{ $t("reference.characterReference") }}
      <br />
      <font-awesome-icon icon="address-card" />
      {{ edition.name || $t("common.customScript") }}
    </h3>

    <div
      class="team bootlegger"
      v-if="edition.bootlegger && edition.bootlegger.length"
    >
      <aside>
        <h4>{{ $t("reference.rules") }}</h4>
      </aside>
      <ul>
        <li v-for="(rule, index) in edition.bootlegger" :key="index">
          <span
            class="icon"
            :style="{
              backgroundImage: `url(${getImage(
                { id: 'bootlegger', team: 'loric', edition: 'loric' },
                0,
              )})`,
            }"
          ></span>
          <div class="role">
            <span class="ability">{{ rule }}</span>
          </div>
        </li>
        <li></li>
        <li></li>
      </ul>
    </div>

    <div
      v-for="(teamRoles, team) in rolesGrouped"
      :key="team"
      :class="['team', team]"
    >
      <aside>
        <h4>{{ $team(team) }}</h4>
      </aside>
      <ul>
        <li v-for="role in teamRoles" :class="[team]" :key="role.id">
          <span
            class="icon"
            v-if="role.id"
            :style="{
              backgroundImage: `url(${getImage(role, 0)})`,
            }"
          ></span>
          <div class="role">
            <span class="player" v-if="Object.keys(playersByRole).length">{{
              playersByRole[role.id] ? playersByRole[role.id].join(", ") : ""
            }}</span>
            <span class="name">{{ role.name }}</span>
            <span class="ability">{{ role.ability }}</span>
          </div>
        </li>
        <li :class="[team]"></li>
        <li :class="[team]"></li>
      </ul>
    </div>

    <div class="team jinxed" v-if="jinxed.length">
      <aside>
        <h4>{{ $t("reference.jinxed") }}</h4>
      </aside>
      <ul>
        <li v-for="(jinx, index) in jinxed" :key="index">
          <span
            class="icon"
            :style="{
              backgroundImage: `url(${getImage(jinx.first, 0)})`,
            }"
          ></span>
          <span
            class="icon"
            :style="{
              backgroundImage: `url(${getImage(jinx.second, 0)})`,
            }"
          ></span>
          <div class="role">
            <span class="name"
              >{{ jinx.first.name }} & {{ jinx.second.name }}</span
            >
            <span class="ability">{{ jinx.reason }}</span>
          </div>
        </li>
        <li></li>
        <li></li>
      </ul>
    </div>
  </component>
</template>

<script>
import SidePanel from "../SidePanel";
import Modal from "./Modal";
import { mapGetters, mapMutations, mapState } from "vuex";

export default {
  components: {
    Modal,
    SidePanel,
  },
  props: {
    closeAll: Boolean,
    forceVisible: Boolean,
    hideSwitch: Boolean,
    presentation: {
      type: String,
      default: "modal",
    },
  },
  computed: {
    containerComponent: function () {
      return this.presentation === "panel" ? "SidePanel" : "Modal";
    },
    isDisplayed: function () {
      return (this.forceVisible || this.modals.reference) && this.roles.size;
    },
    /**
     * Return a list of jinxes in the form of role IDs and a reason
     * @returns {*[]} [{first, second, reason}]
     */
    jinxed: function () {
      const jinxed = [];
      const pushAllJinxes = (role, jinxes) => {
        jinxes.forEach((reason, second) => {
          if (this.roles.get(second)) {
            jinxed.push({
              first: role,
              second: this.roles.get(second),
              reason,
            });
          }
        });
      };
      this.roles.forEach((role) => {
        if (this.jinxes.get(role.id))
          pushAllJinxes(role, this.jinxes.get(role.id));
        if (role.jinxes) pushAllJinxes(role, role.jinxes);
      });
      return jinxed;
    },
    rolesGrouped: function () {
      const rolesGrouped = {};
      this.roles.forEach((role) => {
        if (!rolesGrouped[role.team]) {
          rolesGrouped[role.team] = [];
        }
        rolesGrouped[role.team].push(role);
      });
      delete rolesGrouped["traveller"];
      return rolesGrouped;
    },
    playersByRole: function () {
      if (this.grimoire.isPublic) return {};
      const players = {};
      this.players.forEach(({ name, role }) => {
        if (role && role.id && role.team !== "traveller") {
          if (!players[role.id]) {
            players[role.id] = [];
          }
          players[role.id].push(name);
        }
      });
      return players;
    },
    ...mapGetters(["getImage"]),
    ...mapState(["roles", "modals", "edition", "grimoire", "jinxes"]),
    ...mapState("players", ["players"]),
  },
  methods: {
    showNightOrder() {
      if (this.presentation === "panel") {
        this.$emit("show-sheet", "nightOrder");
        return;
      }
      this.toggleModal("nightOrder");
    },
    closeSheet() {
      if (this.presentation === "panel") {
        this.$emit("close-sheet");
        return;
      }
      if (this.closeAll) {
        this.$store.commit("toggleModal");
        return;
      }
      this.toggleModal("reference");
    },
    ...mapMutations(["toggleModal"]),
  },
};
</script>

<style lang="scss" scoped>
@import "../../vars.scss";

.toggle {
  position: absolute;
  left: 20px;
  top: 15px;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
  z-index: 5;
  svg {
    width: 100%;
    height: 100%;
  }
  &:hover {
    color: red;
  }
}

h3 {
  margin: 0 0 12px;
  svg {
    vertical-align: middle;
  }
  line-height: 90%;
}

.townsfolk {
  .name {
    color: $townsfolk;
  }
  aside {
    background: linear-gradient(-90deg, $townsfolk, transparent);
  }
}
.outsider {
  .name {
    color: $outsider;
  }
  aside {
    background: linear-gradient(-90deg, $outsider, transparent);
  }
}
.minion {
  .name {
    color: $minion;
  }
  aside {
    background: linear-gradient(-90deg, $minion, transparent);
  }
}
.demon {
  .name {
    color: $demon;
  }
  aside {
    background: linear-gradient(-90deg, $demon, transparent);
  }
}

.jinxed {
  .name {
    color: $fabled;
  }
  aside {
    background: linear-gradient(-90deg, $fabled, transparent);
  }
}

.bootlegger {
  aside {
    background: linear-gradient(-90deg, $loric, transparent);
  }
}

.team {
  display: flex;
  align-items: stretch;
  width: 100%;
  &:not(:last-child):after {
    content: " ";
    display: block;
    width: 25%;
    height: 1px;
    background: linear-gradient(90deg, #ffffffaa, transparent);
    position: absolute;
    left: 0;
    bottom: 0;
  }
  aside {
    width: 30px;
    display: flex;
    flex-grow: 0;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    align-content: center;
    overflow: hidden;
    text-shadow: 0 0 4px black;
  }

  h4 {
    text-transform: uppercase;
    text-align: center;
    transform: rotate(90deg);
    transform-origin: center;
    font-size: 80%;
  }

  &.jinxed {
    .icon {
      margin: 0 -5px;
    }
  }
}

ul {
  flex-grow: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  padding: 5px 0;

  li {
    display: flex;
    align-items: center;
    flex: 1 1 260px;
    min-width: 0;
    .icon {
      width: 46px;
      background-size: cover;
      background-position: 0 -10px;
      flex-shrink: 0;
      flex-grow: 0;
      &:after {
        content: " ";
        display: block;
        padding-top: 75%;
      }
    }
    .role {
      line-height: 80%;
      flex-grow: 1;
      min-width: 0;
    }
    .name {
      font-weight: bold;
      font-size: 75%;
      display: block;
    }
    .player {
      color: #888;
      float: right;
      font-size: 60%;
      max-width: 45%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .ability {
      font-size: 70%;
      overflow-wrap: anywhere;
    }
  }
}

.panel-presentation {
  h3 {
    margin: 4px 36px 8px;
    font-size: var(--sheet-ref-title-size, 18px);
    line-height: 1.08;
  }

  .team {
    &:not(:last-child):after {
      width: 18%;
    }

    aside {
      width: 24px;
    }

    h4 {
      font-size: 58%;
    }
  }

  ul {
    padding: 2px 0;

    li {
      flex-basis: var(--sheet-ref-card-basis, 240px);
      padding: 1px 4px 3px 0;

      .icon {
        width: var(--sheet-ref-icon-size, 58px);
      }

      .role {
        line-height: 72%;
      }

      .name {
        font-size: 66%;
      }

      .player {
        font-size: 52%;
      }

      .ability {
        font-size: 58%;
        line-height: 88%;
      }
    }
  }
}

/** break into 1 column below 1200px **/
@media screen and (max-width: 1199.98px) {
  .toggle {
    width: 20px;
    height: 15px;
  }
  ul {
    li {
      width: 100%;
      padding: 0px 5px 5px 0px;
      .icon {
        width: 6vh;
      }
      .role {
        line-height: 100%;
      }
      .name {
        font-size: 100%;
      }
      .player {
        font-size: 100%;
      }
      .ability {
        font-size: 90%;
        text-wrap: wrap;
        line-height: 80%;
      }
    }
  }
}

// if screen is less than 800px, make it 90%
@media screen and (max-width: 800px) {
  .modal {
    max-width: 90%;
  }
  ul {
    li {
      aside h4 {
        font-size: 16px;
      }
      .icon {
        width: 9vh;
      }
      .role {
        line-height: 125%;
        font-size: 150%;
      }
    }
  }
}

/** trim icon size on maximized one-column sheet **/
@media screen and (max-width: 991.98px) {
  .characters .modal.maximized ul li .icon {
    width: 5.1vh;
  }
}
</style>
